<template>
    <div>
        <h2>Connect Your Instagram Account</h2>
        <div class="ig-login-page">
            <div class="left">
                <img src="/static/img/instagram/login-left.png" width="380" height="580" />
            </div>
            <div class="right">
                <i
                    data-visualcompletion="css-img"
                    role="img"
                    style="
                        background-image: url('/static/img/instagram/instagram-login.png');
                        background-position: 0px -502px;
                        background-size: 347px 606px;
                        width: 175px;
                        height: 51px;
                        background-repeat: no-repeat;
                        display: inline-block;
                    "
                />

                <form class="form" autocomplete="chrome-off">
                    <a-input
                        placeholder="instagram username"
                        v-model="auth.username"
                        autocomplete="chrome-off"
                        name="ig-name"
                    />
                    <a-input-password
                        placeholder="instagram password"
                        v-model="auth.password"
                        autocomplete="new-password"
                        name="ig-password"
                    />

                    <a-button type="primary" @click="saveAuthData" :disabled="loading || isAuthenticating">
                        Log in
                    </a-button>
                </form>

                <a-alert
                    v-if="!(isAuthenticating || submitted) && isAuthError"
                    message="Authentication Failed"
                    description="Please check your username and password and try again."
                    type="error"
                    class="mt-2"
                    show-icon
                />

                <a-alert
                    v-if="!(isAuthenticating || submitted) && isAuthChallengeRequired"
                    message="Authentication Failed - Challenge Required"
                    description="Please check your email and follow the instructions to complete the login process from your mobile device or desktop."
                    type="error"
                    class="mt-2"
                    show-icon
                />
                <a-alert
                    v-if="isAuthenticating || submitted"
                    message="Authenticating..."
                    type="info"
                    class="mt-2"
                    show-icon
                >
                    <p slot="description">
                        <a-spin class="mr-2">
                            <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                        </a-spin>
                        Please wait while we authenticate your account.
                    </p>
                </a-alert>
            </div>
        </div>
    </div>
</template>

<script>
import CONFIG from "../../../../../config/config";
import { mapActions, mapState } from "vuex";
import log2 from "../../../../../utils/log2";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import { message } from "ant-design-vue";

const STATES = CONFIG.INSTAGRAM.STATES;
const log = log2("Authentication");
export default {
    name: "Authentication",
    data() {
        return {
            imageRefreshKey: 0,
            continueToWait: false,
            STATES,
            auth: {
                username: "",
                password: "",
            },
            loading: false,
            submitted: false,
        };
    },

    computed: {
        ...mapState({
            site: (state) => state.site.site,
            settings: (state) => state.setting.settings,
            savedInstagramAuthData: (state) => _.get(state.setting.settings, "instagram.auth"),
            isSettingsInitialized: (state) => state.setting.initialized,
            initialized: (state) => state.instagram.info.initialized,
            status: (state) => state.instagram.info.status,
            isAuthenticating: (state) => state.instagram.info.status.status === STATES.AUTHENTICATING,
            isAuthError: (state) => state.instagram.info.status.status === STATES.AUTH_FAILED,
            isAuthChallengeRequired: (state) => state.instagram.info.status.status === STATES.CHALLENGE_REQUIRED,
        }),
    },

    methods: {
        ...mapActions({
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        async saveAuthData() {
            if (!this.auth.username || !this.auth.password) {
                message.error("Please enter username and password");
                return;
            }
            this.loading = true;
            sendSocketMessage("instagram save-auth-data", {
                siteId: this.site._id,
                username: this.auth.username,
                password: this.auth.password,
            });
            this.submitted = true;
        },
    },
    mounted() {},
    beforeDestroy() {},
    watch: {
        savedInstagramAuthData(newData) {
            if (newData && this.loading) {
                this.loading = false;
            }
        },
        status: {
            handler(newStatus, oldStatus) {
                log("status changed", newStatus.status);
                if (newStatus.status !== oldStatus.status) {
                    this.submitted = false;
                }
            },
            deep: true,
        },
        submitted(newVal) {
            if (newVal) {
                setTimeout(() => {
                    if (this.isAuthChallengeRequired || this.isAuthError) {
                        this.submitted = false;
                    }
                }, 3000);
            }
        },
    },
};
</script>

<style lang="scss">
.ig-login-page {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;

    .right {
        padding: 10px 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        border: 1px solid rgb(219, 219, 219);
        border-radius: 1px;
        box-sizing: border-box;
        flex-shrink: 0;
        font: inherit;
        font-size: 100%;
        margin: 0 0 10px;
        position: relative;
        vertical-align: baseline;
        flex-grow: 1;
        margin-top: 12px;
        max-width: 350px;
        min-width: 350px;

        .form {
            margin-top: 20px;
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
}
</style>
